import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=0d5d14d1&scoped=true"
import script from "./scale.vue?vue&type=script&lang=js"
export * from "./scale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d14d1",
  null
  
)

export default component.exports